import React, {Component} from 'react';
import DatePickerCustom from '../common/form/DatePickerCustom';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

import 'react-datepicker/dist/react-datepicker.css';

class Dates extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let {
            startTime: {
                input: startTimeInput,
                input: {
                    value: startTime
                }
            },
            endTime: {
                input: endTimeInput,
                input: {
                    value: endTime
                }
            },
            intl
        } = this.props;

        return <div>
            <div className="form-group row">
                <label className="col-sm-2 col-form-label"><b>{intl.formatMessage(messages.publishedAt)}</b></label>
                <div className="col-sm-10">
                    <DatePickerCustom
                        selected={startTime ? moment.unix(startTime) : moment()}
                        minDate={moment()}
                        formInput={startTimeInput}
                    />
                    <small className="text-muted">(dd-mm-åååå)</small>
                </div>
            </div>
            <div className="form-group row">
                <label className="col-sm-2 col-form-label"><b>{intl.formatMessage(messages.endDate)}</b></label>
                <div className="col-sm-10">
                    <DatePickerCustom
                        minDate={startTime ? moment.unix(startTime) : moment()}
                        selected={endTime ? moment.unix(endTime) : moment()}
                        formInput={endTimeInput}
                    />
                    <small className="text-muted">(dd-mm-åååå)</small>
                </div>
            </div>
        </div>
    }
}

export default injectIntl(Dates);


// WEBPACK FOOTER //
// ./web/src/components/jobs/JobDate.jsx